import { useIsSharedFeed } from '@/hooks/useIsSharedFeed';

import { useIsSourceConnected } from './useIsSourceConnected';

export const usePublicSourceInfo = ({
  sourceId,
}: UsePublicSourceInfoParams) => {
  const {
    isConnected,
    isLoading: isLoadingSource,
    type: sourceType,
  } = useIsSourceConnected(sourceId);
  const { isSharedData } = useIsSharedFeed();

  return {
    showPriority: sourceType === 'rss_news' && isConnected && !isSharedData,
    isLoading: isLoadingSource,
    isConnected: isConnected,
    type: sourceType as PublicSourceType,
  };
};

type PublicSourceType = 'exchanges' | 'rss_news';

type UsePublicSourceInfoParams = {
  sourceId: string;
};
